import React from 'react';
import logo from '../../images/logo-yellow.svg';
import styles from './auth-panel.module.css';
import './auth-components.css';

type AuthPanelProps = {
  message?: string;
  children: React.ReactNode;
};

function AuthPanel(props: AuthPanelProps) {
  let message = null;
  if (props.message) {
    message = (
      <div className={styles.message}>
        <p className='paragraph-sb'>{props.message}</p>
      </div>
    );
  }

  return (
    <div className={styles.header}>
      <div className={styles.panel}>
        <img src={logo} alt='logo' />
        {message}
        {props.children}
      </div>
    </div>
  )
}

export default AuthPanel;